export default __webpack_public_path__ + "static/media/welcomeGif.00e6fd8c.gif";